import { Inset } from 'syf-component-library/ui/spacing';
import styled from 'styled-components';
export const ScreenWrapper = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const ErrorMessageContainer = styled(Inset) `
  margin: 0;
  display: flex;
  justify-content: center;
`;
